<template>
  <div class="content cuaderno-container" v-if="idioma">
    <div class="row" v-if="!mostrarRefugios">
      <div class="form-group col-12 col-md-4">
        <label for="fechas" class="text-white">{{idioma.filtro.entrada}}<sup>*</sup></label>
        <input type="date" name="fechas" id="fechas"
               v-model="fecha"
               class="form-control"
        >
      </div>
      <div class="form-group col-12 col-md-4 personas" >
        <label for="personas" class="text-white">{{idioma.filtro.personas}}<sup>*</sup></label>
        <input type="number" max="25" min="1" name="personas"
               id="personas" class="form-control" v-model="personas"
        >
        <!-- <small class="text-light">{{idioma.filtro.personas}}</small> -->
      </div>
      <div class="form-group col-12 col-md-4 personas mt-4" >
        <button class="btn btn-success" @click="cargarRefugios">{{idioma.filtro.btnMostrar}}</button>
      </div>
    </div>
    <div class="cuaderno-ruta w-100 flex-grow-1 d-flex flex-column" v-else>
      <CuadernoRuta 
      :texto="idioma.cuaderno" 
      :refugios="refugios" 
      :personas="parseInt(personas)"
      :lang="i18n"
      @limpiarFiltros="limpiarFiltros"
      ></CuadernoRuta>
      
    </div>
    
  </div>
</template>

<script>

import CuadernoRuta from "@/components/CuadernoRuta"
import { EventBus } from './helpers/event-bus';

export default {
  name: 'App',
  props: {
    i18n: String,
    refugios: Array
  },
  data() {
    return {
      cargadoRefugios: false,
      cargadoParkings: false,
      fecha: '',
      personas: null,
      idioma: null,
      mostrarRefugios: false,
    }
  },
  async created() {
    this.$store.dispatch('refugios/getAllRefugios').then( () => this.cargadoRefugios = true );
    this.$store.dispatch('parkings/getAllParkings').then( () => this.cargadoParkings = true );
    const raw = await fetch(`https://api.entrepyr.eu/widgetLanguage/${this.i18n}/routebuilder.json`)
    const data = await raw.json()
    this.idioma = data.data
    EventBus.$on('limpiarFiltros', this.limpiarFiltros);
  },
  components: {
    CuadernoRuta
  },
  methods: {
    cargarRefugios() {
      this.$store.dispatch('cuaderno/entrada', this.fecha);
      this.$store.dispatch('cuaderno/personas', this.personas);
      this.refugios.forEach(ref => {
        const data = this.$store.state.refugios.all.find(r => 
          parseInt(r.id) === parseInt(ref)
        );
      

        this.$store.dispatch('cuaderno/addRefugio', {
          id: parseInt(ref), 
          registrarFecha: false, 
          xsalto:data.xsalto
          });
      });
      this.mostrarRefugios = true;
    },
    limpiarFiltros() {
      this.personas = null;
      this.fecha = '';
      this.mostrarRefugios = false;
    }
  }
}
</script>